
export const PreferredDeliveryDate = () => {
    return <div className='py-1 px-2 cursor-pointer flex items-center'>
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 72 72" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M36 59.2C48.813 59.2 59.2 48.813 59.2 36C59.2 23.187 48.813 12.8 36 12.8C23.187 12.8 12.8 23.187 12.8 36C12.8 48.813 23.187 59.2 36 59.2ZM38.9 27.3C38.9 25.6984 37.6016 24.4 36 24.4C34.3984 24.4 33.1 25.6984 33.1 27.3V33.1H27.3C25.6984 33.1 24.4 34.3983 24.4 36C24.4 37.6016 25.6984 38.9 27.3 38.9H33.1V44.7C33.1 46.3016 34.3984 47.6 36 47.6C37.6016 47.6 38.9 46.3016 38.9 44.7V38.9H44.7C46.3016 38.9 47.6 37.6016 47.6 36C47.6 34.3983 46.3016 33.1 44.7 33.1H38.9V27.3Z" fill="#828282" />
        </svg>
        <span>{"Preferred Delivery Date"}</span>
    </div>
};

export const AddNote = () => {
    return <div className='py-1 px-2 cursor-pointer flex items-center'>
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 72 72" fill="none">
            <path d="M33.5833 19.0833H21.5C18.8306 19.0833 16.6667 21.2473 16.6667 23.9167V50.5C16.6667 53.1694 18.8306 55.3333 21.5 55.3333H48.0833C50.7527 55.3333 52.9167 53.1694 52.9167 50.5V38.4167M49.499 15.6657C51.3865 13.7781 54.4468 13.7781 56.3343 15.6657C58.2219 17.5532 58.2219 20.6135 56.3343 22.501L35.5854 43.25H28.75L28.75 36.4146L49.499 15.6657Z" stroke="#828282" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span>{"Add Note"}</span>
    </div>
};

export const RemoveButton = ({ handler, className }: { handler: React.MouseEventHandler; className:string }) => {
    return <div className={`${className} py-1 px-2 cursor-pointer flex items-center`} >
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 72 72" fill="none" onClick={handler}>
            <path d="M52.9167 23.9167L50.8206 53.261C50.64 55.7903 48.5353 57.75 45.9996 57.75H26.0004C23.4647 57.75 21.36 55.7903 21.1794 53.261L19.0833 23.9167M31.1667 33.5833V48.0833M40.8333 33.5833V48.0833M43.25 23.9167V16.6667C43.25 15.332 42.168 14.25 40.8333 14.25H31.1667C29.832 14.25 28.75 15.332 28.75 16.6667V23.9167M16.6667 23.9167H55.3333" stroke="#828282" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span className="text-[16px] text-[#000000] " onClick={handler}>{"Remove"}</span>
    </div>
};

export const CartInSufficientStockText = () => {

    return <div className={"text-[#FF0000] text-[15px] leading-[17px] flex !items-center gap-1.5 md:text-[20px] md:leading[24.2px]"}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#EB5757" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

        <span>Insufficient stock</span>
    </div>
};
